import { ResourceContextProvider, useRecordContext } from "react-admin";
import QueryContextProvider from "./QueryContextProvider";
import useQueryController from "./useQueryController";

const QueryField = (props) => {
    const {
        children,
        query_name,
        filter = {},
        aggregate = {},
        params = {},
        id,
    } = props;

    const record = useRecordContext(props);

    const resource = id ? { "id": id } : record;

    const controllerProps = useQueryController(resource, { query_name, record, filter, aggregate, params });

    return (
        <ResourceContextProvider value={record}>
            <QueryContextProvider value={controllerProps}>
                {children}
            </QueryContextProvider>
        </ResourceContextProvider>
    )
}

export default QueryField;
